import {mapState} from "vuex";

export default {
  data(){
    return {
      popoverWidth: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      const that = this;
      this.$erd.listenTo(document.getElementById("main"), function(element) {
        that.init();
      });
      setTimeout(function(){
        that.init();
      },1000)
      window.onresize = () => {
        return (() => {
          this.init();
        })()
      };
    });
  },
  computed: {
    ...mapState(['collapse']),
  },
  watch: {
    popoverWidth(val){
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if(!this.timer){
        // 一旦监听到的popoverWidth值改变，就将其重新赋给data里的popoverWidth
        this.popoverWidth = val
        this.timer = true
        let that = this
        setTimeout(function(){
          // 打印popoverWidth变化的值
          // console.log(that.popoverWidth)
          that.timer = false
        },400)
      }
    },
    collapse(val){
      let that = this
      setTimeout(function(){
        that.init();
      },400)
    },
  },
  methods: {
    init() {
      this.popoverWidth = document.getElementById('main').scrollWidth - 26;
      // console.log(this.popoverWidth)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js